import MuiBaseModal from "../../common/modal/MuiModal";
import ShowCardAccessToken from "./ShowCardAccessToken";

interface ICreateRole {
  onClose: (payload: boolean) => void;
  open: boolean;
  tokenId: number;
}

export default function ShowAccessTokenModal({
  onClose,
  open,
  tokenId,
  
}: ICreateRole) {
  return (
    <MuiBaseModal
      open={open}
      onClose={() => onClose(false)}
      title={"نمایش توکن"}
      hasCloseIcon
    >
      <ShowCardAccessToken  tokenId={tokenId} />
    </MuiBaseModal>
  );
}
